module.exports = __webpack_public_path__ + "media/images/card-tickets-spaces-b64472068002f5b8adc08ad612c9c4e6.svg";